import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import M from "@/libs/mapping.js";
import { AUTH_SERVICE } from "@/datas/authservice";

Vue.use(Vuex);

/**
 * 화면 갱신시 토큰 셋팅 test 코드
 */
// const enhanceAccessToeken = () => {
//   const accessToken = localStorage.getItem("accessToken");
//   if (!accessToken) return;
//   axios.defaults.headers.common["Authorization"] = accessToken;
// };
// enhanceAccessToeken();

/**
 * store
 */
export default new Vuex.Store({
  state: {
    mode: null,
    expires_at: null,
    accessToken: null,
    refreshToken: null,
    mallId: null,
    appCode: null,
    mallType: null,
    entries: null,
    progressDisplay: false,
    alert: {
      display: false,
      msg: "",
    },
    circularProgress: {
      html: "",
      display: false,
      value: 0,
    },
  },
  getters: {},
  mutations: {
    SET_ENTRIES(state, entires) {
      state.entries = entires;
    },
    SET_APP_CODE(state, app_code) {
      state.appCode = app_code;
    },
    SET_MALL_ID(state, mall_id) {
      state.mallId = mall_id;
    },
    /**
     * 토큰 저장
     * @param {*} state
     * @param {*} accessToken
     */
    REFRESH_ACCESS_TOKEN(state, accessToken) {
      state.accessToken = accessToken;
      // 토큰을 로컬 스토리지에 저장
      localStorage.setItem(`${state.mallId}_accessToken`, accessToken);
    },
    CHANGE_VERSION(state, version) {
      state.mode = version;
    },
    SET_VERSION(state, payload) {
      if (payload.class === null) {
        state.mode = AUTH_SERVICE.APP_MODE.ANY;
        state.expires_at = null;
      } else {
        state.mode = payload.class;
        state.expires_at = payload.expires_at;
      }
    },
    SET_MALL_TYPE(state, mallType) {
      state.mallType = mallType;
    },
    SET_SHOPLUS_ACCESS_TOKEN(state, accessToken) {
      state.accessToken = accessToken;
      sessionStorage.shoplusAuthServiceAccessToken = accessToken;
    },
    SET_SHOPLUS_REFRESH_TOKEN(state, refreshToken) {
      state.refreshToken = refreshToken;
    },
  },
  actions: {
    SET_ACCESS_TOKEN({ commit }, data) {
      commit("REFRESH_ACCESS_TOKEN", data.access_token);
      axios.defaults.headers.common["Authorization"] = data.access_token;
    },
    /**
     * 토큰인증 refresh
     * @param {*} param0
     */
    async REFRESH_ACCESS_TOKEN({ commit }) {
      let data = await M.api(M.entry("/auth/refresh"));
      if (data.access_token) {
        commit("REFRESH_ACCESS_TOKEN", data.access_token);
        axios.defaults.headers.common["Authorization"] = data.access_token;
      }
    },
    CHANGE_VERSION({ commit }, version) {
      if (version) {
        commit("CHANGE_VERSION", version);
      }
    },
    async SET_CERT_PRODUCTS_VERSION({ commit }) {
      try {
        let data = await M.api(M.entry("/cert/products/class"));
        if (Object.prototype.hasOwnProperty.call(data, "class")) {
          commit("SET_VERSION", data);
        }
      } catch (e) {
        if (e.response.status !== 401) {
          commit("SET_VERSION", { class: null });
        }
      }
    },
    async SET_MALL_TYPE({ commit }, mallType) {
      commit("SET_MALL_TYPE", mallType);
    },
    async SET_SHOPLUS_ACCESS_TOKEN({ commit }, accessToken) {
      commit("SET_SHOPLUS_ACCESS_TOKEN", accessToken);
      axios.defaults.headers.common["Authorization"] = accessToken;
    },
    async SET_SHOPLUS_REFRESH_TOKEN({ commit }, refreshToken) {
      commit("SET_SHOPLUS_REFRESH_TOKEN", refreshToken);
    },
    async SET_SHOPLUE_ACCESS_REFRESH_TOKEN({ commit }, refreshToken) {
      let data = await M.api(M.entry("/shoplus/auth/refresh"), {
        refresh_token: refreshToken,
      });
      commit("SET_SHOPLUS_ACCESS_TOKEN", data.access_token);
      axios.defaults.headers.common["Authorization"] = data.access_token;
    },
  },
});
